module.exports = __webpack_public_path__ + "img/805.3deea2e0.svg";